/**
 * @author shao
 * @date 2018/01/11
 * @project kaoshizhongxin
 * @example <div v-before:login="{handler: bindFn, args: [1,2,3,...]} </div>
 * <div v-before="{handler: bindFn} </div>
 */
import Vue from 'vue'
import { isLogin } from '../utils/auth'
import { LOGIN_URL, APPLICATION_ID } from '../config'
import { Base64UrlEncode } from '../utils'

const HANDLE = `_beforeHandle_`
const DIRECTIVE_NAME = `before`

const warn = Vue.util.warn

const bind = (el, binding, vnode) => {
  unbind(el)
  let handle = binding.value
  let bindingArg = binding.arg || 'login' // 默认登录
  if (typeof handle !== 'object') {
    warn(
      'v-' + binding.name + '="' +
      binding.expression + '" expects a object value, ' +
      'got ' + handle
    )
    return
  }
  el[HANDLE] = {
    args: handle.args,
    callback (e) {
      e.stopPropagation()
      let args = (handle.args || []).concat(e)
      if (bindingArg === 'login') {
        if (isLogin()) {
          return handle.handler.apply(vnode.context, args)
        } else {
          let url = window.location.href
          window.location.href = LOGIN_URL + '?from=' + Base64UrlEncode(url) + '&id=' + APPLICATION_ID
          // store.dispatch('common/goLoginPage', {
          //   args: handle.args,
          //   handler: handle.handler,
          //   success: handle.success,
          //   successArgs: handle.successArgs,
          //   context: vnode.context,
          //   $event: e
          // }).then(res => {
          //   // handle.handler.apply(vnode.context, args)
          // })
        }
      }
    }
  }
  el.addEventListener('click', el[HANDLE].callback, false)
}

function unbind (el) {
  if (el[HANDLE]) {
    el.removeEventListener('click', el[HANDLE].callback, false)
    delete el[HANDLE]
  }
}

function update (el, binding, vnode) {
  if (binding.value === binding.oldValue) return
  bind(el, binding, vnode)
}

const plugin = {
  name: DIRECTIVE_NAME,
  install (Vue) {
    Vue.directive(DIRECTIVE_NAME, {
      bind,
      unbind,
      update
    })
  }
}

export default plugin
